var _defs, _rect, _line, _line2, _line3, _polyline, _polyline2, _polyline3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteps02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Take_Surveys",
    "data-name": "Take Surveys",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #df4f71;\n        isolation: isolate;\n        opacity: .2;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #df4f71;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17,
    y: 4,
    width: 14,
    height: 24
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17,
    y1: 16,
    x2: 31,
    y2: 16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17,
    y1: 3.75,
    x2: 31,
    y2: 3.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17,
    y1: 28.25,
    x2: 31,
    y2: 28.25
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1 3.75 3.75 6.5 9.25 1"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1 16 3.75 18.75 9.25 13.25"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1 28.25 3.75 31 9.25 25.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps02);
export default __webpack_public_path__ + "static/media/steps-02.8bb8b559025a8425d72539dd9fd018ea.svg";
export { ForwardRef as ReactComponent };